import { dicom } from './dicom.query';
import { radiologist } from './radiologist.query';
import { study } from './study.query';

export const hi = { dicom, radiologist, study };
